//
// user-settings-api-service.js
//
// Copyright (c) 2016 by Curalate, Inc.
//

((() => {
    angular.module('curalate').service('UserSettingsApiService', ['$http', '$q',
        function ($http, $q) {
            const BASE_URL = '/api/user-settings';

            this.readAllFeatures = userId => processResponse(
                 $http.get(
                     `${BASE_URL}/readAll/${userId}`
                 )
             );

            this.readAllFeaturesByEmail = email => processResponse(
                $http.get(
                    `${BASE_URL}/readAllFromEmail/${encodeURIComponent(email)}`
                )
            );

            function processResponse(httpPromise) {
                return httpPromise.catch(handleErrorResponse);
            }

            function handleErrorResponse(errorResponse) {
                const error = errorResponse.data;
                if (typeof error.message !== 'undefined') {
                    return $q.reject(error.message);
                } else {
                    return $q.reject(error);
                }
            }
        },
    ]);
}))();
